/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { containerStyles } from "../../theme/commonStyle";

const textContainerStyle = {
  textContainer: {
    ...containerStyles,
    maxWidth: "700px",
    "& h2": {
      marginTop: 0,
    },
  },
};

export default textContainerStyle;
